export const NAME = 'app';

export const PRODUCTION_HOSTNAME = 'jok.cpas.cz';

export const SURFLY_PRODUCTION_WIDGET_KEY = '1b28fd4fd1cc497dbdfc8b4d7cfb1f4f';
export const SURFLY_TEST_WIDGET_KEY = 'ee9c6addba4c4dc0a16beaa250e80bef';

export const SURFLY_INITIALIZATION_PRODUCTION_HOSTNAME = 'https://sdileni.cpas.cz/surfly.js';
export const SURFLY_INITIALIZATION_TEST_HOSTNAME = 'https://sdileni-test.cpas.cz/surfly.js';
